/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {WindowRef} from '../window-ref.service';

export interface Environment {
  production?: boolean;
  appName?: string;
  appVersion?: string;
  appVersionCodename?: string;
  buildNumber?: number | string;
  environmentName?: string;
  apiMap?: unknown;
  appLauncherUrls?: unknown;
  featureToggleMap?: unknown;
  auth?: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  public environment: Environment = environment;

  constructor(private readonly winRef: WindowRef) {
    this.augmentEnvironment();
  }

  /**
   * Grab environment from the window and add it to the Angular environment object.
   */
  private augmentEnvironment(): void {
    const dynamicConfig: Environment = this.winRef.nativeWindow['__env'];
    if (dynamicConfig) {
      Object.assign(this.environment, dynamicConfig);
    }
  }
}
